enum SalesActionTypesEnum {
  SAVE_SALES_INFO = 'SAVE_SALES_INFO',
  SAVE_UNRECONCILED_HARDWARE = 'SAVE_UNRECONCILED_HARDWARE',
}

export default SalesActionTypesEnum;
